module.exports = __webpack_public_path__ + "img/shortcut.bb859193.png";